module.exports = __webpack_public_path__ + "static/media/myanimelist.ab34d71a.svg";